import React from 'react';
import CreateEntry from 'views/Client/CreateEntry';
import Heading from '@hubins/components/Heading';
import __ from 'localisation';

const OrdersCreateTof = () => {
  return (
    <>
      <Heading size="3" className='s-top-xl s-bottom-md'>{__('create_premium_in_kind')}</Heading>
      <CreateEntry />
    </>
  );
};

export default OrdersCreateTof;
